package mo.web.portfoliofront.infrastructure.data

import mo.web.portfoliofront.infrastructure.models.Blog
import mo.web.portfoliofront.infrastructure.models.BlogType

val BLOG_GENERATED_LIST = listOf(
    
                    Blog(
                        title = "My Favorite Games of 2025",
                        subtitle = "I promised myself I'd touch grass, but the ground was frozen and the game was warm.",
                        url = "/blog/favoritegames2025",
                        created = "2025-12-30",
                        readtime = 5,
                        blogType = BlogType.Gaming
                    )
                    ,
    
                    Blog(
                        title = "Yet Another Blog..",
                        subtitle = "I keep making these, but don't make the blog posts!",
                        url = "/blog/yetanotherblog",
                        created = "2025-04-24",
                        readtime = 10,
                        blogType = BlogType.Programming
                    )
                    ,
)
